export default {
    feedsList: [],
    fetchingFeedError: false
}


// WEBPACK FOOTER //
// ./src/features/homepage/redux/initialState.js